import { Modal } from '@/core/components/Modal/Modal';
import { OverlayStyle } from '@/core/components/Modal/Modal.types';
import { Button, ButtonVariant } from '@/core/components/Button';
import { Paragraph } from '@/core/components/Typography';
import { Icon } from '@/core/components/Icons';

import {
  ButtonsContainer,
  CloseButton,
  ModalContainer,
  ModalHeader,
} from './DeleteAnalysisConfirmModal.styles';

type DeleteAnalysisConfirmModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
};

export const DeleteAnalysisConfirmModal = ({
  isOpen,
  onCancel,
  onConfirm,
  isDeleting = false,
}: DeleteAnalysisConfirmModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onCancel}
    overlayStyle={OverlayStyle.BLUR}
  >
    <ModalContainer>
      <ModalHeader>
        <Paragraph type="bold">Do you really want to delete this analysis?</Paragraph>
        <CloseButton
          type="button"
          onClick={onCancel}
          aria-label="Close modal"
          disabled={isDeleting}
        >
          <Icon
            name="Close"
            size={14}
          />
        </CloseButton>
      </ModalHeader>
      <ButtonsContainer>
        <Button
          variant={ButtonVariant.WARNING}
          onClick={onConfirm}
          disabled={isDeleting}
        >
          {isDeleting ? 'Deleting…' : 'YES, DELETE'}
        </Button>
        <Button
          variant={ButtonVariant.SECONDARY}
          onClick={onCancel}
          disabled={isDeleting}
        >
          CANCEL
        </Button>
      </ButtonsContainer>
    </ModalContainer>
  </Modal>
);
